import { render, staticRenderFns } from "./SelectAssigned.vue?vue&type=template&id=a55a8db0&"
import script from "./SelectAssigned.vue?vue&type=script&lang=js&"
export * from "./SelectAssigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports